import IconOutlink from '@apollo/icons/default/IconOutlink.svg';
import { Alert, AlertBannerStatus, Button, Link } from '@apollo/orbit';
import { Location, LocationDescriptor } from 'history';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

type AlertWithCtaArgs = {
  status: AlertBannerStatus;
  id: string;
  message: string | React.ReactElement;
  maybeCTA?: {
    href: string;
    text?: string;
  };
  maybeAction?: {
    action: () => void;
    text?: string;
  };
  maybeRoute?: {
    to:
      | LocationDescriptor<unknown>
      | ((location: Location<unknown>) => LocationDescriptor<unknown>);
    text?: string;
  };
};

const AlertButton = ({
  action,
  text = 'Recreate your router',
}: {
  action: () => void;
  text?: string;
}) => {
  return (
    <Button
      onClick={action}
      variant="buttonLink"
      className="ml-1"
      rightIcon={<IconOutlink />}
    >
      {text}
    </Button>
  );
};

const AlertLink = ({
  href,
  text = 'Learn more',
}: {
  href: string;
  text?: string;
}) => {
  return (
    <Link to={href} className="ml-1" isExternal>
      {text}
    </Link>
  );
};

const AlertRoute = ({
  to,
  text = 'Learn more',
}: {
  to:
    | LocationDescriptor<unknown>
    | ((location: Location<unknown>) => LocationDescriptor<unknown>);
  text?: string;
}) => (
  <ReactRouterLink to={to} className="font-semibold underline">
    {text}
  </ReactRouterLink>
);

export const AlertWithCTA = ({
  status,
  id,
  message,
  maybeCTA,
  maybeAction,
  maybeRoute,
}: AlertWithCtaArgs) => {
  return (
    <Alert status={status} key={id}>
      <>
        {message}
        {maybeCTA ? <AlertLink {...maybeCTA} /> : null}
        {maybeAction ? <AlertButton {...maybeAction} /> : null}
        {maybeRoute ? <AlertRoute {...maybeRoute} /> : null}
      </>
    </Alert>
  );
};
